module.exports = __webpack_public_path__ + "static/media/delete.1c54e591.svg";